import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import CustomersList from '../components/CustomersList';
import CustomerLicenses from '../components/CustomersLicenses';
import TenantFeatures from '../components/TenantFeatures';
import DeletedCustomersList from '../components/DeletedCustomersList';
import HomePageCards from '../components/HomePageCards';

function Home() {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showDeleted, setShowDeleted] = useState(false);

  const fetchCustomers = useCallback(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers`)
      .then((res) => res.json())
      .then((data) => {
        setCustomers(data);
        setSelectedCustomer(null);
      })
      .catch((err) => console.error('Failed to fetch customers:', err));
  }, []);

  useEffect(() => {
    if (!showDeleted) {
      fetchCustomers();
    }
  }, [showDeleted, fetchCustomers]);

  const refreshActiveCustomers = () => {
    fetchCustomers();
  };

  const handleToggleShowDeleted = () => {
    setShowDeleted(!showDeleted);
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
  };

  console.log('Backend URL:', process.env.REACT_APP_BACKEND_URL);
  const handleDeleteCustomer = (customerId) => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers/${customerId}`, {
      method: 'DELETE',
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to delete customer');
        }
        return res.json();
      })
      .then(() => {
        alert('Customer deleted successfully');
        refreshActiveCustomers();
        if (selectedCustomer && selectedCustomer.CustomerID === customerId) {
          setSelectedCustomer(null);
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Error deleting customer.');
      });
  };

  const handleMarkVerified = (customerId) => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers/${customerId}/verify`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to verify customer');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data.message);
        refreshActiveCustomers();
      })
      .catch((error) => {
        console.error('Error marking customer as verified:', error);
      });
  };

  return (
    <div style={{ margin: '20px' }}>
      <Link 
        to="/customers" 
        style={{ 
          display: 'inline-block', 
          marginBottom: '10px', 
          padding: '16px 32px', 
          backgroundColor: '#d13438', 
          color: 'white', 
          textDecoration: 'none', 
          borderRadius: '4px',
          fontSize: '18px',
          fontWeight: 'bold',
          boxShadow: '0 4px 8px rgba(209, 52, 56, 0.3)',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#c02a2f';
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 12px rgba(209, 52, 56, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#d13438';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 8px rgba(209, 52, 56, 0.3)';
        }}
      >
        Try new customer interface
      </Link>
      <h1>Customers & Licenses</h1>
      <label>
        <input
          type="checkbox"
          checked={showDeleted}
          onChange={handleToggleShowDeleted}
          style={{ marginRight: '8px' }}
        />
        Show Deleted Customers
      </label>

      {showDeleted ? (
        <DeletedCustomersList
          refreshActiveCustomers={refreshActiveCustomers}
        />
      ) : (
        <div style={{ display: 'flex', gap: '40px' }}>
          <CustomersList
            customers={customers}
            onSelectCustomer={handleSelectCustomer}
            handleDeleteCustomer={handleDeleteCustomer}
            handleMarkVerified={handleMarkVerified}
          />

          {selectedCustomer && !selectedCustomer.IsDeleted && (
            <div style={{ display: 'flex', gap: '40px', flex: 1 }}>
              <CustomerLicenses customer={selectedCustomer} />
              <TenantFeatures customer={selectedCustomer} />
            </div>
          )}
        </div>
      )}
      <br />
      <hr />
      <HomePageCards />
    </div>
  );
}

export default Home;
